export default __webpack_public_path__ + "static/ndp2-1765f4b548ce126615cb1cfcb10e6880.jpg";